import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, VideoIcon, MicIcon, MessageSquareIcon, ShareIcon } from 'lucide-react';
export function Dashboard() {
  const navigate = useNavigate();
  const [prompts, setPrompts] = useState<any[]>([]);
  const [selectedPrompt, setSelectedPrompt] = useState<any>(null);
  useEffect(() => {
    const storedPrompts = JSON.parse(localStorage.getItem('prompts') || '[]');
    setPrompts(storedPrompts);
  }, []);
  const getResponseIcon = (type: string) => {
    switch (type) {
      case 'video':
        return <VideoIcon className="w-4 h-4" data-id="element-48" />;
      case 'audio':
        return <MicIcon className="w-4 h-4" data-id="element-49" />;
      case 'text':
        return <MessageSquareIcon className="w-4 h-4" data-id="element-50" />;
      default:
        return null;
    }
  };
  return <div className="min-h-screen p-6 text-white" data-id="element-51">
      <div className="max-w-6xl mx-auto space-y-6" data-id="element-52">
        <button onClick={() => navigate('/')} className="flex items-center gap-2 text-white/80 hover:text-white transition-colors" data-id="element-53">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-54" />
          Back
        </button>
        <div className="flex justify-between items-center" data-id="element-55">
          <h1 className="text-4xl font-bold" data-id="element-56">Panel</h1>
          <button onClick={() => navigate('/create')} className="bg-white text-rose-500 px-6 py-3 rounded-xl font-semibold hover:bg-opacity-90 transition-all" data-id="element-57">
            Nowe video
          </button>
        </div>
        <div className="grid lg:grid-cols-2 gap-6" data-id="element-58">
          <div className="space-y-4" data-id="element-59">
            <h2 className="text-2xl font-semibold" data-id="element-60">Twoje nagrania</h2>
            <div className="space-y-3" data-id="element-61">
              {prompts.length === 0 ? <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center" data-id="element-62">
                  <p className="opacity-80" data-id="element-63">
                    Brak. Nagraj swoje pierwsze video!
                  </p>
                </div> : prompts.map(prompt => <div key={prompt.id} onClick={() => setSelectedPrompt(prompt)} className={`bg-white/10 backdrop-blur-sm rounded-xl p-4 cursor-pointer hover:bg-white/20 transition-all ${selectedPrompt?.id === prompt.id ? 'ring-2 ring-white' : ''}`} data-id="element-64">
                    <div className="flex justify-between items-start mb-2" data-id="element-65">
                      <h3 className="font-semibold text-lg" data-id="element-66">{prompt.title}</h3>
                      <button onClick={e => {
                  e.stopPropagation();
                  const url = `${window.location.origin}/prompt/${prompt.id}`;
                  navigator.clipboard.writeText(url);
                  alert('Link copied to clipboard!');
                }} className="p-2 hover:bg-white/20 rounded-lg transition-all" data-id="element-67">
                        <ShareIcon className="w-4 h-4" data-id="element-68" />
                      </button>
                    </div>
                    <p className="text-sm opacity-80" data-id="element-69">
                      {prompt.responses?.length || 0} responses
                    </p>
                    <p className="text-xs opacity-60 mt-1" data-id="element-70">
                      {new Date(prompt.createdAt).toLocaleDateString()}
                    </p>
                  </div>)}
            </div>
          </div>
          <div className="space-y-4" data-id="element-71">
            <h2 className="text-2xl font-semibold" data-id="element-72">Reakcje Studia</h2>
            {!selectedPrompt ? <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center" data-id="element-73">
                <p className="opacity-80" data-id="element-74">Brak.</p>
              </div> : <div className="space-y-3" data-id="element-75">
                {selectedPrompt.responses?.length === 0 ? <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center" data-id="element-76">
                    <p className="opacity-80" data-id="element-77">No responses yet</p>
                  </div> : selectedPrompt.responses?.map((response: any) => <div key={response.id} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 space-y-3" data-id="element-78">
                      <div className="flex items-center gap-2 text-sm opacity-80" data-id="element-79">
                        {getResponseIcon(response.type)}
                        <span className="capitalize" data-id="element-80">
                          {response.type} Response
                        </span>
                        <span className="ml-auto" data-id="element-81">
                          {new Date(response.createdAt).toLocaleDateString()}
                        </span>
                      </div>
                      {response.type === 'video' && <video src={response.content} controls className="w-full rounded-lg" data-id="element-82" />}
                      {response.type === 'audio' && <audio src={response.content} controls className="w-full" data-id="element-83" />}
                      {response.type === 'text' && <p className="bg-white/10 p-4 rounded-lg" data-id="element-84">
                          {response.content}
                        </p>}
                    </div>)}
              </div>}
          </div>
        </div>
      </div>
    </div>;
}